import React from "react"
import clsx from "clsx"

function OverlayArrow({ onClick, side = "left" }) {
  return (
    <button
      aria-label={side === "left" ? "Previous" : "Next"}
      className={clsx(
        "cursor-pointer absolute top-0 bottom-0 left-0 right-0 z-overlayArrow flex flex-col w-full h-full transform focus:outline-none",
        side === "left" ? "-translate-x-full" : "translate-x-full"
      )}
      onClick={onClick}
    />
  )
}

export default OverlayArrow
